import React from 'react';
import withFlagWrapper from '@bubble-ui/hoc-with-flag-wrapper';
import Shape from '@bubble-ui/primitive-shape';
var FlagBI = () => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Shape, {
  fill: "#F0F0F0",
  d: "M25 50c13.807 0 25-11.193 25-25S38.807 0 25 0 0 11.193 0 25s11.193 25 25 25Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#D80027",
  d: "M40.222 5.165c-8.95-6.887-21.494-6.887-30.444 0L25 20.388 40.222 5.164ZM25 29.61 9.778 44.832c8.95 6.887 21.494 6.887 30.444 0L25 29.61Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#6DA544",
  d: "M20.388 25 5.166 9.778c-6.887 8.95-6.887 21.494 0 30.444L20.388 25ZM29.611 25l15.222 15.222c6.887-8.95 6.887-21.494 0-30.444L29.611 25Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#F0F0F0",
  d: "M25 35.869c6.003 0 10.87-4.866 10.87-10.87 0-6.003-4.867-10.869-10.87-10.869-6.003 0-10.87 4.866-10.87 10.87 0 6.003 4.867 10.869 10.87 10.869Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#D80027",
  d: "m25 17.392.941 1.63h1.883l-.942 1.63.942 1.631H25.94L25 23.913l-.942-1.63h-1.882l.941-1.63-.941-1.63h1.883l.94-1.631ZM20.215 25l.942 1.63h1.882l-.941 1.631.941 1.63h-1.882l-.942 1.63-.941-1.63h-1.883l.942-1.63-.942-1.63h1.883l.941-1.63ZM29.785 25l.941 1.63h1.883l-.942 1.631.942 1.63h-1.883l-.941 1.63-.942-1.63h-1.882l.941-1.63-.941-1.63h1.883l.94-1.63Z"
}));
FlagBI.displayName = 'FlagBI';
export default withFlagWrapper(FlagBI);
//# sourceMappingURL=index.js.map